export const ACCOUNT_ENDPOINT={
    forget:`${import.meta.env.VITE_APP_API}/auth/forgot-password`,
    change_password:`${import.meta.env.VITE_APP_API}/auth/change-password`,
    reset_password:`${import.meta.env.VITE_APP_API}/auth/reset-password`,
}